import { useEffect, useState } from 'react';
export const useHasError = ({ src }) => {
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        setHasError(false);
        return () => setHasError(false);
    }, [src]);
    return [hasError, setHasError];
};
